import ApiService from './ApiService'

// The sign-up wizard (views/auth/SignUp) sends everything it collected in this
// one call. The older per-page sign-up calls (SignUp, AddBusinessInformation,
// UpdateMerchant) and the demo-template calls (sign-up, forgot/reset password)
// were removed in Increment 53: no screen used them.
export async function apiMerchantRegister(data, captchaToken) {
    const response = await ApiService.fetchData({
        url: 'Merchant/Register',
        method: 'post',
        data,
        // The Turnstile answer from the page (empty when the check is switched off).
        headers: { 'X-Captcha-Token': captchaToken || '' },
    })
    return response.data
}

export async function apiSignIn (data) {
    return ApiService.fetchData({
        url: '/sign-in',
        method: 'post',
        data
    })
}

export async function apiSignOut (data) {
    return ApiService.fetchData({
        url: '/sign-out',
        method: 'post',
        data
    })
}

